import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import ArrowRightIcon from '@assets/images/arrow-right-icon.svg?react'

import { useObservation } from '@hooks/observation/observation.hook'

import { truncateWithEllipsis } from '@utils/string'

import { Container, Name, Title } from './FormBreadCrumb.styled'

interface Props {
  observationId?: string
}

export const ObservationBreadCrumb: React.FC<Props> = ({ observationId }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const { data, loading } = useObservation(observationId || '')

  const getBasePath = () => {
    const pathParts = location.pathname.split('/')
    const formIndex = pathParts.findIndex((part) => part === 'details')

    if (formIndex !== -1) return pathParts.slice(0, formIndex).join('/')

    return location.pathname
  }

  const handleFormClick = () => {
    navigate(getBasePath())
  }

  const observation = data?.observation

  return (
    <Container>
      <Title onClick={handleFormClick}>{t('modules_shared_components_ObservationBreadCrumb_title')}</Title>

      {observationId && (
        <>
          <ArrowRightIcon />
          {loading || !observation?.name ? (
            <></>
          ) : (
            <Name>{observation?.name && truncateWithEllipsis(observation.name, 20)}</Name>
          )}
        </>
      )}
    </Container>
  )
}
